export class PageViewEvent {
  static eventName = "event:page-view";

  constructor({ location }) {
    this.eventName = PageViewEvent.eventName;
    console.log("eventname for the pageview", this.eventName);
    this.location = location;
    console.log("location for the pageview", this.location);
  }
}
